import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SavedSearchModalService } from 'src/app/services/saved-search-modal/saved-search-modal.service';
import { BidSavedSearchService } from 'src/app/services/bid-saved-search/bid-saved-search.service';
import swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-add-saved-search',
  templateUrl: './add-saved-search.component.html',
  styleUrls: ['./add-saved-search.component.scss']
})
export class AddSavedSearchComponent implements OnInit, OnDestroy {

  @Output() searchSaved = new EventEmitter<void>();

  savedSearchForm!: FormGroup;
  isLoading = false;
  searchData: any = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private _savedSearchModalService: SavedSearchModalService,
    private _bidSavedSearchService: BidSavedSearchService
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    this.setupModalListener();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initializeForm(): void {
    this.savedSearchForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  get name() {
    return this.savedSearchForm.get('name');
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_add_saved_search');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        const serviceData = this._savedSearchModalService.getSearchData();
        if (serviceData) {
          this.searchData = serviceData;
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this._savedSearchModalService.clearSearchData();
        this.resetForm();
      });
    }
  }

  private resetForm(): void {
    this.savedSearchForm.reset();
    this.searchData = null;
    this.isLoading = false;
  }

  private closeModal(): void {
    const modalElement = document.getElementById('kt_modal_add_saved_search');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  onSubmit(): void {
    if (this.savedSearchForm.valid && !this.isLoading && this.searchData) {
      this.isLoading = true;

      const formValue = this.savedSearchForm.value;

      const submitData = {
        name: formValue.name,
        data: this.searchData
      };

      this.subscriptions.push(
        this._bidSavedSearchService.AddData(submitData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            if (response.status) {
              swal.fire({
                title: 'Success!',
                text: 'Search saved successfully',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                this.closeModal();
                this.searchSaved.emit();
                this.resetForm();
              });
            } else {
              swal.fire({
                title: 'Error!',
                text: response.message || 'Failed to save search',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          },
          error: (error) => {
            this.isLoading = false;
            swal.fire({
              title: 'Error!',
              text: 'Failed to save search',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            console.error('Error saving search:', error);
          }
        })
      );
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.savedSearchForm.controls).forEach(key => {
        this.savedSearchForm.get(key)?.markAsTouched();
      });
    }
  }
}
